import axios from "./axios";

const API_URL = axios.defaults.baseURL;
const BASE_URL = "/event/";
const otherUrl = "/category"

export const getCategoryEntity = (eventID, categoryType) => {
    return axios.get(
        API_URL + BASE_URL + eventID + otherUrl + `?category_type=${categoryType}`
    );
};

export const addCategoryEntity = (eventID, payload) => {
    return axios.post(
        API_URL + BASE_URL + eventID + otherUrl, payload
    );
};

export const editCategoryEntity = (eventID, categoryID, payload) => {
    return axios.put(
        API_URL + BASE_URL + eventID + otherUrl + `/${categoryID}`, payload
    );
};

export const deleteCategoryEntity = (module, eventID, categoryID, categoryType, deleteMedia) => {
    const deleteMediaQuery = module == "gallery" ? deleteMedia ? `&delete_media=${deleteMedia}` : !deleteMedia ? `&delete_media=${deleteMedia}` : '' : ""
    return axios.delete(
        API_URL + BASE_URL + eventID + otherUrl + `/${categoryID}` + `?category_type=${categoryType}` + deleteMediaQuery
    );
};

export const reorderCategoryEntity = (eventID, payload) => {
    return axios.put(
        API_URL + BASE_URL + eventID + otherUrl + '/reorder', payload
    );
};

